import React, { useEffect, useState } from "react";
import "./style.scss";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import ButtonCustom from "../../../../features/ButtonCustom/ButtonCustom";
import InputText from "../../../../features/InputText";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { BAD_WEATHER_CHECK_PASS } from "../../../api/apiRoutes";
import { BasketItem } from "../../../models/BasketItem";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";

interface IProps {
  updateBasket: (basket: BasketItem[]) => void;
}

const WeatherTicket: React.FC<IProps> = ({ updateBasket }: IProps) => {
  const { get } = useApiRequest();
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(false);
  const [weatherTrhId, setWeatherTrhId] = useState("");
  const [error, setError] = useState("");

  const onCheckBadWeatherTrhId = async () => {
    const { result, isError, errorTable } = await get(BAD_WEATHER_CHECK_PASS(weatherTrhId));
    if (!isError) {
      updateBasket(result);
      setWeatherTrhId("");
      setError("");
      setOpen(false);
    } else {
      setWeatherTrhId("");
      setError(errorTable);
    }
  };

  useEffect(() => {
    if (isDesktop) {
      setOpen(isDesktop);
    }
  }, [isDesktop]);

  return (
    <div className={"weather-ticket-panel"}>
      <div className={"weather-header"} onClick={isDesktop ? () => {} : () => setOpen(!open)}>
        <p>Dodaj bilet na niepogodę</p>
        {isDesktop && (
          <ButtonCustom
            title={`${open ? "-" : "+"}`}
            className={`button-weather-ticket-color`}
            Icon={open ? AiOutlineMinus : AiOutlinePlus}
            iconPosition={"center"}
            onClick={() => setOpen(!open)}
          />
        )}
      </div>
      {open && (
        <React.Fragment>
          <p>
            Jeśli podczas pobytu deszcz przeszkodzi w zabawie (opady będą trwały minimum 1 godzinę) otrzymasz taki sam
            bilet wstępu za 1 zł. Wprowadź poniżej kod:
          </p>
          <div className={"weather-body"}>
            <InputText
              value={weatherTrhId}
              label={""}
              name={"weatherTrhId"}
              setValue={(value: string) => setWeatherTrhId(value)}
              placeholder={"Kod biletu"}
            />
            <ButtonCustom
              title={`Dodaj`}
              className={`button-weather-add `}
              onClick={() => onCheckBadWeatherTrhId()}
              disabled={!Boolean(weatherTrhId)}
            />
          </div>
          {error && (
            <div className={"error-panel"}>
              <p>{error}</p>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default WeatherTicket;
